import {ChangeDetectorRef, Component, Input, OnInit} from '@angular/core';
import {Item} from "../../models/Item";
import {TimelineService} from "../../services/timeline/timeline.service";
import {debounceTime} from "rxjs/operators";

@Component({
  selector: 'timeline',
  templateUrl: './timeline.component.html',
  styleUrls: ['./timeline.component.scss']
})
export class TimelineComponent implements OnInit {

  @Input() item:Item;

  public data: string[] = ['loading...'];
  protected latestValue: string;

  constructor(
    private timelineService: TimelineService,
    private cdr: ChangeDetectorRef
  ) { }

  ngOnInit() {
    this.latestValue = this.getInitialValue();

    this.timelineService.timelineOptions.pipe(debounceTime(1000)).subscribe(options => {
      this.data = options;
      this.cdr.markForCheck();
    });
  }

  selectValue(event) {
    console.log('selectValue', event);
    let target = (event.originalTarget ? event.originalTarget : event.target);
    this.latestValue = target.options[target.selectedIndex].value;
    this.item.config.setInputValue('__timeline', 'value', this.latestValue);
  }

  selectEvent(item) {
    this.latestValue = item;
    this.item.config.setInputValue('__timeline', 'value', this.latestValue);
    console.log('selectEvent', item);
    // do something with selected item
  }

  onChangeSearch(val: string) {
    this.latestValue = val;
    // fetch remote data from here
    // And reassign the 'data' which is binded to 'data' property.
  }

  onFocused(e){
    console.log('onFocused', e);
    // do something when input is focused
  }

  getInitialValue() {
    return this.item.config.getInputProp('__timeline', 'value');
  }

  getNewEntryText() {
    return 'unknown time frame';
  }

  hasAvailableOptions() {
    this.timelineService.hasAvailableOptions();
  }

}
